export enum FormPanelType {
    customerEmail = 'CUSTOMER_EMAIL',
    invoiceData = 'INVOICE_DATA',
    notes = 'NOTES',
    payment = 'PAYMENT',
    realizationDate = 'REALIZATION_DATE',
    recipientData = 'RECIPIENT_DATA',
    shipmentData = 'SHIPMENT_DATA',
    shipmentForm = 'SHIPMENT_FORM',
    recipientSchoolData = 'RECIPIENT_SCHOOL_DATA',
    payerData = 'PAYER_DATA',
}

export enum FormFieldNames {
    BILLING_ADDRESS = 'billingAddress',
    CITY = 'city',
    COMPANY = 'company',
    CUSTOMER_EMAIL = 'email',
    COUNSEL_PARENTS = 'COUNSEL_PARENTS',
    DIFFERENT_DATA = 'differentData',
    FIRST_NAME = 'firstName',
    LAST_NAME = 'lastName',
    NOTES = 'notes',
    ORDER_TYPE = 'orderType',
    PAYER_ADDRESS = 'payerAddress',
    PAYER_DATA = 'payerData',
    RECIPIENT_ADDRESS = 'recipientAddress',
    RECIPIENT_SCHOOL_DATA = 'recipientSchoolData',
    PAYMENT_METHOD = 'paymentMethod',
    PHONE_NUMBER = 'phoneNumber',
    POST_CODE = 'postcode',
    REALIZATION_DATE = 'realizationDate',
    SCHOOL = 'SCHOOL',
    SCHOOL_EMAIL = 'schoolEmail',
    SHIPPING_ADDRESS = 'shippingAddress',
    SHIPPING_FORM = 'shippingForm',
    STREET = 'street',
    STREET_NUMBER = 'streetNumber',
    TAX_ID_NUMBER = 'taxIdNumber',
    SUBORDINATE_INTERNAL_ID = 'subordinateInternalId',
    RECIPIENT_SCHOOL_IS_SUBORDINATE_UNIT = 'recipientSchoolIsSubordinateUnit',
    RECIPIENT_SCHOOL_IS_GRV = 'recipientSchoolIsGrv',
    RECIPIENT_SCHOOL_HAS_NO_NIP ='recipientSchoolHasNoNip',
    RECIPIENT_SCHOOL_HAS_NO_SUBORDINATE_INTERNAL_ID = 'recipientSchoolHasNoSubordinateInternalId',
    IS_SUBORDINATE_UNIT = 'isSubordinateUnit',
    IS_GRV = 'isGrv',
    HAS_NO_NIP = 'hasNoNip',
    HAS_NO_SUBORDINATE_INTERNAL_ID = 'hasNoSubordinateInternalId',
}

export const {
    BILLING_ADDRESS,
    CITY,
    COMPANY,
    COUNSEL_PARENTS,
    CUSTOMER_EMAIL,
    DIFFERENT_DATA,
    FIRST_NAME,
    LAST_NAME,
    NOTES,
    ORDER_TYPE,
    PAYER_ADDRESS,
    PAYER_DATA,
    RECIPIENT_ADDRESS,
    RECIPIENT_SCHOOL_DATA,
    PAYMENT_METHOD,
    PHONE_NUMBER,
    POST_CODE,
    REALIZATION_DATE,
    SCHOOL,
    SCHOOL_EMAIL,
    SHIPPING_ADDRESS,
    SHIPPING_FORM,
    STREET,
    STREET_NUMBER,
    TAX_ID_NUMBER,
    SUBORDINATE_INTERNAL_ID,
    RECIPIENT_SCHOOL_IS_SUBORDINATE_UNIT,
    RECIPIENT_SCHOOL_IS_GRV,
    RECIPIENT_SCHOOL_HAS_NO_NIP,
    RECIPIENT_SCHOOL_HAS_NO_SUBORDINATE_INTERNAL_ID,
    IS_SUBORDINATE_UNIT,
    IS_GRV,
    HAS_NO_NIP,
    HAS_NO_SUBORDINATE_INTERNAL_ID,
} = FormFieldNames;
